<fieldset class="fieldset-form noPadding height">
  <legend>Warranties
    <ng-template #noAddClaim>
      <framework-hidden [display]="button"></framework-hidden>
    </ng-template>
  </legend>
  <app-warranty-list #warrantiesTable [tableLabel]="'warranties-table-component'" [columns]="warrantiesTableColumns" [readOnly]="readOnly" [smallComponent]="smallComponent">
  </app-warranty-list>
</fieldset>
